<template>
  <div class="content">
    <md-app md-mode="reveal" style="min-height: 400px">
      <md-app-toolbar class="md-primary">
        <md-button
          class="md-icon-button md-primary"
          @click="menuVisible = !menuVisible"
          style="background: #fff"
        >
          <md-icon>menu</md-icon>
        </md-button>
        <span class="md-title"
          >Inspection Analyser
          <div v-if="selectedInspection">
            - {{ selectedInspection.uuid }}
          </div></span
        >
      </md-app-toolbar>

      <md-app-drawer :md-active.sync="menuVisible">
        <md-toolbar class="md-transparent" md-elevation="0"
          >Inspections</md-toolbar
        >
        <md-list>
          <md-list-item
            style="margin-left:0px !important"
            v-for="item in inspections"
            v-bind:key="item.id"
            @click="set_inspection(item)"
          >
            <span class="md-list-item-text"
              >{{ item.uuid.substring(0, 8) }} - ID{{ item.tag }}</span
            >
          </md-list-item>
        </md-list>
      </md-app-drawer>

      <md-app-content style="padding:0px">
        <md-tabs
          class="md-primary"
          md-alignment="fixed"
          v-if="selectedInspection"
        >
          <md-tab
            id="tab-boxplots"
            md-label="1. Administration"
            style="padding: 10px"
            @click="set_page('admin')"
          >
            <div class="md-layout md-gutter" v-if="page == 'admin'">
              <div class="md-layout-item md-size-30">
                <md-progress-spinner
                  v-if="initialising"
                  md-mode="indeterminate"
                ></md-progress-spinner>
                <md-table
                  v-model="inspectionFiles"
                  v-if="inspectionFiles && !initialising"
                  md-card
                >
                  <md-table-toolbar>
                    <h1 class="md-title">Inspection files</h1>
                    <md-button
                      @click="save_selected"
                      type="submit"
                      class="md-danger"
                      style="background-color: #8dc63f"
                      >Save selected files</md-button
                    >
                  </md-table-toolbar>

                  <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell md-label="File name">{{
                      item.name
                    }}</md-table-cell>

                    <md-table-cell md-label="Position">{{
                      item.position
                    }}</md-table-cell>

                    <md-table-cell md-label="Use?">
                      <md-checkbox
                        v-model="item.use"
                        @change="change_inspection_files"
                        >Use for analysis?</md-checkbox
                      >
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </div>
              <div class="md-layout-item md-size-70">
                <md-progress-spinner
                  v-if="bscanLoading"
                  md-mode="indeterminate"
                ></md-progress-spinner>
                <md-card v-if="!bscanLoading && bscans">
                  <md-card-content>
                    Bscan data:
                    <md-field>
                      <label for="file">File</label>
                      <md-select
                        v-model="selectedFile"
                        name="file"
                        id="file"
                        @md-selected="set_plot_data"
                      >
                        <md-option
                          v-for="name in fileNames"
                          :value="name"
                          v-bind:key="name"
                          >{{ name }}</md-option
                        >
                      </md-select>
                    </md-field>
                    <div class="md-layout-item md-size-100">
                      <Plotly
                        :data="bscanPlotData"
                        :layout="layout"
                        :display-mode-bar="true"
                      ></Plotly>
                    </div>
                  </md-card-content>
                </md-card>
              </div>
            </div>
          </md-tab>

          <md-tab
            id="tab-boxplots2"
            md-label="2. Peak detect"
            style="padding: 10px"
            @click="set_page('peakdetect')"
          >
            <div class="md-layout md-gutter" v-if="page == 'peakdetect'">
              <div class="md-layout-item md-size=30">
                <md-card>
                  <md-card-content>
                    <div class="md-layout-item md-small-size-100">
                      <h5>1. File Information</h5>
                    </div>
                    <div class="md-layout">
                      <div class="md-layout-item md-size-50">
                        <md-field>
                          <label for="file"
                            >Original wallthickness to use</label
                          >
                          <md-select v-model="orgWTUse" name="file" id="file">
                            <md-option value="expected"
                              >Expected:
                              {{
                                selectedInspection.wallthickness_expected
                              }}</md-option
                            >
                            <md-option value="validation"
                              >Validation:
                              {{
                                selectedInspection.wallthickness_expected_validation
                              }}</md-option
                            >
                          </md-select>
                        </md-field>
                      </div>

                      <div class="md-layout-item md-size-50">
                        <md-field>
                          <label for="file">Material</label>

                          <md-input
                            type="text"
                            id="filetype"
                            name="filtype"
                            v-model="selectedInspection.material"
                            required
                            disabled
                        /></md-field>
                      </div>
                    </div>
                    <div class="md-layout">
                      <div class="md-layout-item md-size-50">
                        <md-field>
                          <label for="filetag">File Tag</label>
                          <md-input
                            type="text"
                            id="filetag"
                            name="filetag"
                            v-model="selectedTag"
                            required
                            disabled
                        /></md-field>
                      </div>

                      <div class="md-layout-item md-size-50">
                        <md-field>
                          <label for="filetype">Measurement Type</label>
                          <md-input
                            type="text"
                            id="filetype"
                            name="filtype"
                            v-model="selectedType"
                            required
                            disabled
                        /></md-field>
                      </div>
                    </div>

                    <div class="md-layout">
                      <div class="md-layout-item md-size-50">
                        <md-field>
                          <label for="file">Coating outer</label>

                          <md-input
                            type="text"
                            id="filetype"
                            name="filtype"
                            v-model="selectedInspection.coating"
                            required
                            disabled
                        /></md-field>
                      </div>

                      <div class="md-layout-item md-size-50">
                        <md-field>
                          <label for="file">Coating inner</label>

                          <md-input
                            type="text"
                            id="filetype"
                            name="filtype"
                            v-model="selectedInspection.coating_inner"
                            required
                            disabled
                        /></md-field>
                      </div>
                    </div>
                    <div class="md-layout-item md-small-size-100">
                      <h5>2. Peak detect settings</h5>
                    </div>

                    <div class="md-layout">
                      <div class="md-layout-item md-size-20">
                        <md-button
                          type="submit"
                          class="md-danger"
                          @click="detect_peaks"
                          :disabled="disablePeaksButton"
                          >Calculate peaks and features</md-button
                        >
                        <md-progress-spinner
                          :md-diameter="30"
                          md-mode="indeterminate"
                          v-if="waitingForPeaks"
                        ></md-progress-spinner>
                      </div>
                    </div>
                    <div class="md-layout-item md-size-100">
                      <md-field>
                        <label for="file">Algorithm</label>
                        <md-select
                          v-model="selectedAlgorithm"
                          name="file"
                          id="file"
                        >
                          <md-option
                            v-for="value in peakDetectAlgorithms"
                            :value="value"
                            v-bind:key="value"
                            >{{ value }}</md-option
                          >
                        </md-select>
                      </md-field>
                    </div>
                    <div class="md-layout">
                      <div class="md-layout-item md-small-size-100">
                        <md-field>
                          <label for="fwmin">Search start</label>
                          <md-input
                            type="number"
                            id="fwmin"
                            name="fwmin"
                            v-model="searchStart"
                            required
                        /></md-field>
                      </div>
                      <div class="md-layout-item md-small-size-100">
                        <md-field>
                          <label for="fwmax">Search stop</label>
                          <md-input
                            type="number"
                            id="fwmax"
                            name="fwmax"
                            v-model="searchStop"
                            required
                        /></md-field>
                      </div>
                      <div class="md-layout-item md-small-size-100">
                        <md-field>
                          <label for="fwmin">Min dist. BW</label>
                          <md-input
                            type="number"
                            id="fwmin"
                            name="fwmin"
                            v-model="minDistance"
                            required
                        /></md-field>
                      </div>
                      <div class="md-layout-item md-small-size-100">
                        <md-field>
                          <label for="fwmax">Max dist. BW</label>
                          <md-input
                            type="number"
                            id="fwmax"
                            name="fwmax"
                            v-model="maxDistance"
                            required
                        /></md-field>
                      </div>
                      <div class="md-layout-item md-small-size-100">
                        <md-field>
                          <label for="fwnoise">FW-noise</label>
                          <md-input
                            type="number"
                            id="fwnoise"
                            name="fwnoise"
                            v-model="noiseFW"
                            required
                        /></md-field>
                      </div>
                    </div>
                    <div class="md-layout">
                      <div class="md-layout-item md-small-size-100">
                        <md-field>
                          <label for="bwnoise">BW-noise</label>
                          <md-input
                            type="number"
                            id="bwnoise"
                            name="bwnoise"
                            v-model="noiseBW"
                            required
                        /></md-field>
                      </div>
                      
                    </div>
                    <div class="md-layout">
                      <div class="md-layout-item md-small-size-100">
                        <md-field>
                          <md-switch v-model="preferLastPeak">Last peak</md-switch></md-field>
                      </div>
                      
                    </div>
                    <div class="md-layout">
                      <div class="md-layout-item">
                        <md-field>
                          <label>Comment</label>
                          <md-textarea
                            v-model="comments_analyst[selectedFileCorrelation]"
                          ></md-textarea>
                        </md-field>
                        <md-button
                          type="submit"
                          class="md-danger"
                          @click="save_comments"
                          >Save Comments</md-button
                        >
                      </div>
                    </div>
                  </md-card-content>
                </md-card>
              </div>
              <div class="md-layout-item md-size-70">
                <md-progress-spinner
                  v-if="bscanCorrelationLoading"
                  md-mode="indeterminate"
                ></md-progress-spinner>
                <md-card v-if="!bscanCorrelationLoading && bscansCorrelation">
                  <md-card-content>
                    Bscan data:
                    <md-field>
                      <label for="file">File</label>
                      <md-select
                        v-model="selectedFileCorrelation"
                        name="file"
                        id="file"
                        @md-selected="set_plot_data_correlation"
                      >
                        <md-option
                          v-for="name in fileNamesCorrelation"
                          :value="name"
                          v-bind:key="name"
                          >{{ name }}</md-option
                        >
                      </md-select>
                    </md-field>
                    <div class="md-layout-item md-size-100">
                      <Plotly
                        :data="bscanCorrelationPlotData"
                        :layout="layout"
                        :display-mode-bar="true"
                      ></Plotly>
                      <Plotly
                        :data="wtPlotData"
                        :layout="layoutWT"
                        :display-mode-bar="true"
                      ></Plotly>
                    </div>
                  </md-card-content>
                </md-card>
              </div>
            </div>
          </md-tab>

          <md-tab
            id="tab-boxplots3"
            md-label="3. Mapping"
            style="padding: 10px"
            @click="set_page('mapping')"
          >
            <div class="md-layout md-gutter" v-if="page == 'mapping'">
              <div class="md-layout-item md-size-30">
                <md-table
                  v-model="mappingSettings"
                  v-if="mappingSettings"
                  md-card
                >
                  <md-table-toolbar>
                    <h1 class="md-title">Inspection files</h1>
                    <md-button
                      @click="save_mapping_settings"
                      type="submit"
                      class="md-danger"
                      style="background-color: #8dc63f"
                      >Save mapping settings</md-button
                    >
                  </md-table-toolbar>

                  <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell md-label="File name">{{
                      item.name
                    }}</md-table-cell>

                    <md-table-cell md-label="Use odo distance?">
                      <md-checkbox v-model="item.use_odo"
                        >Use odo distance?</md-checkbox
                      >
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </div>
              <div class="md-layout-item md-size-70">
                <md-card>
                  <h5>Odo measured distance</h5>
                  <Plotly
                    :data="odoDistanceData"
                    :layout="layoutWT"
                    :display-mode-bar="true"
                  ></Plotly>
                </md-card>

                <md-card>
                  <h5>Alternative estimated distance</h5>
                  <Plotly
                    :data="altDistanceData"
                    :layout="layoutWT"
                    :display-mode-bar="true"
                  ></Plotly>
                </md-card>
              </div>
            </div>
          </md-tab>

          <md-tab
            id="tab-boxplots4"
            md-label="4. Filter"
            style="padding: 10px"
            @click="set_page('filter')"
          >
            <div class="md-layout" v-if="page == 'filter'">
              <div class="md-layout-item md-size-30">
                <md-card>
                  <md-card-content v-if="filterSettings">
                    <div class="md-title">Outlier filter settings</div>

                    <div class="md-layout">
                      <div class="md-layout-item md-small-size-100">
                        <md-field>
                          <label for="offsetmax">Upper Offset</label>
                          <md-input
                            type="number"
                            id="offsetmax"
                            name="offsetmax"
                            v-model="filterSettings.upperOffset"
                            @change="change_offset"
                            required
                        /></md-field>
                      </div>
                      <div class="md-layout-item md-small-size-100">
                        <md-field>
                          <label for="offsetmin">Lower Offset</label>
                          <md-input
                            type="number"
                            id="offsetmin"
                            name="offsetmin"
                            v-model="filterSettings.lowerOffset"
                            @change="change_offset"
                            required
                        /></md-field>
                      </div>
                    </div>
                    <div class="md-layout">
                      <div class="md-layout-item md-small-size-100">
                        <md-field>
                          <label for="offsetmax">Upper threshold</label>
                          <md-input
                            type="number"
                            id="thsetmax"
                            name="thsetmax"
                            v-model="filterSettings.upperTH"
                            @change="change_offset"
                            required
                        /></md-field>
                      </div>
                      <div class="md-layout-item md-small-size-100">
                        <md-field>
                          <label for="offsetmin">Lower threshold</label>
                          <md-input
                            type="number"
                            id="thsetmin"
                            name="thsetmin"
                            v-model="filterSettings.lowerTH"
                            @change="change_offset"
                            required
                        /></md-field>
                      </div>
                    </div>
                    <div class="md-layout">
                      <md-button
                        type="submit"
                        class="md-danger"
                        @click="filter_wt"
                        >Apply filter</md-button
                      >
                    </div>
                  </md-card-content>
                </md-card><!--
                <md-card v-if="permissions.includes('publish:results')">
                  <md-card-content>
                    <md-button
                      type="submit"
                      class="md-danger"
                      @click="publish_results"
                      >Publish result</md-button
                    >
                  </md-card-content>
                </md-card> -->
              </div>
              <div class="md-layout-item md-size-70">
                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                    <md-card>
                      <md-card-content>
                        <md-field>
                          <label for="file">File</label>
                          <md-select
                            v-model="fileFilterSelected"
                            name="file"
                            id="file"
                            @md-selected="
                              set_wt_filter_file(fileFilterSelected)
                            "
                          >
                            <md-option
                              v-for="name in fileNamesCorrelation"
                              :value="name"
                              v-bind:key="name"
                              >{{ name }}</md-option
                            >
                          </md-select>
                        </md-field>
                        <Plotly
                          :data="wtFilterData"
                          :layout="layoutWT"
                          :display-mode-bar="true"
                        ></Plotly
                      ></md-card-content>
                    </md-card>
                  </div>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item md-size-60">
                    <md-card>
                      <md-card-content>
                        <Plotly
                          :data="filteredDataDistance"
                          :layout="wtDistLayout"
                          :display-mode-bar="true"
                        ></Plotly>
                      </md-card-content>
                    </md-card>
                  </div>
                  <div class="md-layout-item md-size-40">
                    <md-card>
                      <md-card-content>
                        <Plotly
                          :data="filteredDataRoll"
                          :layout="layoutWT"
                          :display-mode-bar="true"
                        ></Plotly>
                      </md-card-content>
                    </md-card>
                  </div>
                </div>
              </div>
            </div>
          </md-tab>
          <md-tab
            id="tab-boxplots5"
            md-label="5. Publish"
            style="padding: 10px"
            @click="set_page('publish')"
          >
            <div class="md-layout" v-if="page == 'publish'">
              <div class="md-layout-item md-size-30">
                <md-button
                      @click="publish_results"
                      type="submit"
                      class="md-danger"
                      style="background-color: #8dc63f"
                      >Publish</md-button
                    >
              </div>
            </div>
          </md-tab>
        </md-tabs>
      </md-app-content>
    </md-app>
  </div>
</template>

<script>
//import { Plotly } from "vue-plotly";
import axios from "axios";
import { mapState } from "vuex";
import { Plotly } from "vue-plotly";
import "vue-slider-component/theme/default.css";
import { files } from "jszip";
export default {
  name: "Analyser",
  components: { Plotly },
  created() {},
  data() {
    return {
      preferLastPeak: false,
      searchStart: 0,
      searchStop: 0,
      minDistance: 0,
      maxDistance: 0,
      fileFilterSelected: null,
      mappingSettings: null,
      odoDistanceData: [],
      odoDistance: null,
      altDistanceData: [],
      altDistance: null,
      waitingForPeaks: false,
      wtPlotData: null,
      orgWTUse: "validation",
      noPeaks: 2,
      materials: ["AC", "GGIJ"],
      currentPeaks: {},
      leaching: [0, 0],
      thirdPeakMax: false,
      frontWall: [0, 0],
      noiseFW: 70.0,
      FWMax: false,
      backWall: [0, 0],
      noiseBW: 50.0,
      BWMax: true,
      selectedTag: "",
      selectedType: "",
      page: "admin",
      fileNames: [],
      fileNamesCorrelation: [],
      selectedFile: "",
      selectedFileCorrelation: "",
      menuVisible: false,
      inspections: [],
      selectedInspection: null,
      bscansCorrelation: null,
      bscanCorrelationPlotData: null,
      inspectionFiles: null,
      analyserApi: {
        server: process.env.VUE_APP_ANALYSER_SERVER,
        files: "pipescanner/analyser/v1/files/",
        bscans: "pipescanner/analyser/v1/ut/get-bscans/",
        bscansCorrelation: "pipescanner/analyser/v1/ut/get-bscans-correlated/",
        init: "pipescanner/analyser/v1/init/",
        save_files: "pipescanner/analyser/v1/save-selected/",
        peak_detect: "pipescanner/analyser/v1/ut/peak-detect/",
        get_saved_peaks: "pipescanner/analyser/v1/ut/get-saved-peaks/",
        get_comments: "pipescanner/analyser/v1/comments/",
        save_comments: "pipescanner/analyser/v1/save-comments/",
        odo_distance: "pipescanner/analyser/v1/mapping/get-distance-odo/",
        alt_distance:
          "pipescanner/analyser/v1/mapping/get-distance-alternative/",
        get_mapping_settings:
          "pipescanner/analyser/v1/mapping/get-mapping-settings/",
        save_mapping_settings:
          "pipescanner/analyser/v1/mapping/save-mapping-settings/",
        get_wt: "pipescanner/analyser/v1/filter/get-wt-filter/",
        filter_wt: "pipescanner/analyser/v1/filter/filter-wt/",
        publish: "pipescanner/analyser/v1/publish/" // uuid/group
      },
      wtFilterObject: null,
      wtFilterData: [],
      comments_analyst: {},
      bscanLoading: false,
      bscanCorrelationLoading: false,
      bscans: null,
      bscanPlotData: null,
      layout: {
        yaxis: {
          autorange: "reversed",
          range: [50, 250],
        },
        showlegend: true,
      },
      layoutWT: {
        showlegend: true,
      },
      initialising: false,
      peakDetectAlgorithms: [
        "correlation"
        //"hybrid",
        //"regiondetectioncorrelation",
        //"regiondetectionhilbert",
      ],
      selectedAlgorithm: "correlation",
      filterSettings: null,
      filteredDataDistance: [],
      filteredDataRoll: [],
      wtDistLayout: {
        xaxis: {
          title: {
            text: "Distance (mm)",
            font: {
              family: "Nunito, sans-serif",
              size: 16,
              color: "#7f7f7f",
            },
          },
        },
        yaxis: {
          range: [0.0, 10.0],
          title: {
            text: "Wallthickness (mm)",
            font: {
              family: "Nunito, sans-serif",
              size: 16,
              color: "#7f7f7f",
            },
          },
        },
      },
    };
  },
  mounted() {
    this.populate_menu();
  },
  watch: {
    /**
     * Watching the page change.
     * @param {string} newPage - go-to page
     */
    page: function(newPage) {
      console.log(newPage);
      if (newPage == "peakdetect" && !this.bscansCorrelation) {
        console.log("gaan");
        this.get_bscans_correlation(this.selectedInspection.uuid);
      } else if (newPage == "mapping") {
        if (!this.odoDistance) {
          this.get_distances();
        }
        if (!this.mappingSettings) {
          this.get_mapping_settings();
        }
      } else if (newPage == "filter") {
        this.get_wt_filter_data();
      }
    },
    /**
     * Watching the inspection files change
     * @param {Array} newArr - changed array
     */
    inspectionFiles: function(newArr) {
      console.log(newArr);
      this.fileNamesCorrelation = this.inspectionFiles
        .filter((obj) => {
          return obj.use;
        })
        .map((x) => x.name);
      this.fileFilterSelected = this.fileNamesCorrelation[0];
      //console.log(this.fileNamesCorrelation);
      this.selectedFileCorrelation = this.fileNamesCorrelation[0];
    },
    /**
     * Watching the selected file for the correlation filter change
     * @param {string} newSel - new selected file
     */
    selectedFileCorrelation: function(newSel) {
      this.selectedType = this.inspectionFiles
        .filter((obj) => {
          return obj.name == newSel;
        })
        .map((x) => x.type)[0];
      this.selectedTag = this.inspectionFiles
        .filter((obj) => {
          return obj.name == newSel;
        })
        .map((x) => x.position)[0];
    },
  },
  computed: {
    ...mapState(["groupSelected", "groupServices", "apiEndpoints"]),
    /**
     * Computed property for disabling button during peak detect call (no clicking one million times)
     * @return {bool} boolean for disabling/enabling
     */
    disablePeaksButton() {
      if (this.waitingForPeaks) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    /**
     * Function to publish results
     */
    async publish_results() {
      const token = await this.$auth.getTokenSilently();
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const endpoint =
        this.analyserApi.server +
        this.analyserApi.publish +
        this.selectedInspection.uuid +
        "/" +
        this.groupSelected;

      axios
        .get(endpoint, config)
        .then((response) => {
          this.$notify({
            message: response.data.message,
            icon: "check",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success",
          });
        })
        .catch((error) => {
          this.$notify({
            message: error,
            icon: "error",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
    /**
     * handle file changes
     */
    change_inspection_files() {
      this.fileNamesCorrelation = this.inspectionFiles
        .filter((obj) => {
          return obj.use;
        })
        .map((x) => x.name);
      this.fileFilterSelected = this.fileNamesCorrelation[0];
      this.selectedFileCorrelation = this.fileNamesCorrelation[0];
      console.log(this.fileNamesCorrelation);
    },
    /**
     * Function to call wallthickness filter
     */
    async filter_wt() {
      var settings = {
        inspectionFile: this.fileFilterSelected,
        upperOffset: parseFloat(this.filterSettings.upperOffset),
        lowerOffset: parseFloat(this.filterSettings.lowerOffset),
        upperTH: parseFloat(this.filterSettings.upperTH),
        lowerTH: parseFloat(this.filterSettings.lowerTH),
      };
      const token = await this.$auth.getTokenSilently();
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const endpoint =
        this.analyserApi.server +
        this.analyserApi.filter_wt +
        this.selectedInspection.uuid + "/" + this.groupSelected;

      axios
        .post(endpoint, settings, config)
        .then((response) => {
          this.wtFilterObject[this.fileFilterSelected].results.wt =
            response.data.wt;
          this.wtFilterObject[this.fileFilterSelected].results.s =
            response.data.s;
          this.wtFilterObject[this.fileFilterSelected].results.roll =
            response.data.roll;
          this.wtDistLayout.yaxis.range[1] =
            Math.max(...response.data.wt) + 2.0;
          this.filteredDataDistance = [
            {
              x: response.data.s,
              y: response.data.wt,
              mode: "markers",
              type: "scatter",
              name: "WT (mm)",
            },
          ];
          this.filteredDataRoll = [
            {
              theta: response.data.roll.map((x) => (x * 180) / Math.PI),
              r: response.data.wt,
              mode: "markers",
              name: "Wallthickness",
              type: "scatterpolar",
            },
          ];
        })
        .catch((error) => {
          this.$notify({
            message: error,
            icon: "error",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
    /**
     * Function to fetch filter data
     */
    async get_wt_filter_data() {
      const token = await this.$auth.getTokenSilently();
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const endpoint =
        this.analyserApi.server +
        this.analyserApi.get_wt +
        this.selectedInspection.uuid + "/" + this.groupSelected;
      axios
        .get(endpoint, config)
        .then((response) => {
          if (!("message" in response.data)) {
            this.wtFilterObject = response.data;
            //this.filterSettings = response.data[this.fileFilterSelected].setttings;
            console.log(response.data[this.fileFilterSelected].results);
            this.filterSettings =
              response.data[this.fileFilterSelected].settings;
            //console.log(this.wtFilterObject)
            this.set_wt_filter_file(this.fileFilterSelected);
          }
        })
        .catch((error) => {
          this.$notify({
            message: error,
            icon: "error",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
    /**
     * Handle changes in offset
     */
    change_offset() {
      this.wtFilterObject[
        this.fileFilterSelected
      ].settings = this.filterSettings;

      this.wtFilterData[1].y = this.wtFilterObject[
        this.fileFilterSelected
      ].wt_rolling.map((x) => {
        var z = x + parseFloat(this.filterSettings.upperOffset);
        if (z < parseFloat(this.filterSettings.upperTH)) {
          return z;
        } else {
          return parseFloat(this.filterSettings.upperTH);
        }
      });
      this.wtFilterData[2].y = this.wtFilterObject[
        this.fileFilterSelected
      ].wt_rolling.map((x) => {
        var z = x + parseFloat(this.filterSettings.lowerOffset);
        if (z > parseFloat(this.filterSettings.lowerTH)) {
          return z;
        } else {
          return parseFloat(this.filterSettings.lowerTH);
        }
      });
    },
    /**
     * Set graph data to selected file.
     * @summary If the description is long, write your summary here. Otherwise, feel free to remove this.
     * @param {string} file - filename
     */
    set_wt_filter_file(file) {
      this.filterSettings = this.wtFilterObject[file].settings;

      this.wtFilterData = [];
      this.wtFilterData.push({
        y: this.wtFilterObject[file].wt,
        mode: "markers",
        type: "scatter",
        name: "WT (mm)",
      });
      this.wtFilterData.push({
        y: this.wtFilterObject[file].wt_rolling.map((x) => {
          var z = x + this.filterSettings.upperOffset;
          if (z < parseFloat(this.filterSettings.upperTH)) {
            return z;
          } else {
            return parseFloat(this.filterSettings.upperTH);
          }
        }),
        mode: "lines",
        type: "scatter",
        name: "Upper filter limit",
      });
      this.wtFilterData.push({
        y: this.wtFilterObject[file].wt_rolling.map((x) => {
          var z = x + this.filterSettings.lowerOffset;
          if (z > parseFloat(this.filterSettings.lowerTH)) {
            return z;
          } else {
            return parseFloat(this.filterSettings.lowerTH);
          }
        }),
        mode: "lines",
        type: "scatter",
        name: "Lower filter limit",
      });

      this.wtDistLayout.yaxis.range = [
        0,
        Math.max(...this.wtFilterObject[file].results.wt) + 2.0,
      ];

      this.filteredDataDistance = [
        {
          x: this.wtFilterObject[file].results.s,
          y: this.wtFilterObject[file].results.wt,
          mode: "markers",
          type: "scatter",
          name: "WT (mm)",
        },
      ];
      this.filteredDataRoll = [
        {
          theta: this.wtFilterObject[file].results.roll.map(
            (x) => (x * 180) / Math.PI
          ),
          r: this.wtFilterObject[file].results.wt,
          mode: "markers",
          name: "Wallthickness",
          type: "scatterpolar",
        },
      ];
    },
    /**
     * Function to save mapping settings
     */
    async save_mapping_settings() {
      const token = await this.$auth.getTokenSilently();
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const endpoint =
        this.analyserApi.server +
        this.analyserApi.save_mapping_settings +
        this.selectedInspection.uuid +
        "/" +
        this.groupSelected;
      axios
        .post(endpoint, this.mappingSettings, config)
        .then((response) => {
          this.$notify({
            message: response.data["message"],
            icon: "check",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success",
          });
        })
        .catch((error) => {
          this.$notify({
            message: error,
            icon: "error",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
    /**
     * Function to fetch mapping settings
     */
    async get_mapping_settings() {
      const token = await this.$auth.getTokenSilently();
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };

      const endpoint =
        this.analyserApi.server +
        this.analyserApi.get_mapping_settings +
        this.selectedInspection.uuid +
        "/" +
        this.groupSelected;

      axios
        .get(endpoint, config)
        .then((response) => {
          this.mappingSettings = response.data;
        })
        .catch((error) => {
          this.$notify({
            message: error,
            icon: "error",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
    /**
     * Function to fetch measurement distances
     */
    async get_distances() {
      const token = await this.$auth.getTokenSilently();
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const odo_endpoint =
        this.analyserApi.server +
        this.analyserApi.odo_distance +
        this.selectedInspection.uuid +
        "/" +
        this.groupSelected;
      const alternative_endpoint =
        this.analyserApi.server +
        this.analyserApi.alt_distance +
        this.selectedInspection.uuid +
        "/" +
        this.groupSelected;
      axios
        .get(odo_endpoint, config)
        .then((response) => {
          this.odoDistance = response.data;
          this.odoDistanceData = response.data.map((obj) => {
            return {
              y: obj.distance,
              mode: "lines",
              type: "scatter",
              name: obj.name,
            };
          });
        })
        .catch((error) => {
          this.$notify({
            message: error,
            icon: "error",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
      axios
        .get(alternative_endpoint, config)
        .then((response) => {
          this.altDistance = response.data;
          this.altDistanceData = response.data.map((obj) => {
            return {
              y: obj.distance,
              mode: "lines",
              type: "scatter",
              name: obj.name,
            };
          });
        })
        .catch((error) => {
          this.$notify({
            message: error,
            icon: "error",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
    /**
     * Function to save comments
     */
    async save_comments() {
      const token = await this.$auth.getTokenSilently();
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const save_comments_endpoint =
        this.analyserApi.server +
        this.analyserApi.save_comments +
        this.selectedInspection.uuid +
        "/" +
        this.groupSelected;
      axios
        .post(save_comments_endpoint, this.comments_analyst, config)
        .then((response) => {
          this.$notify({
            message: response.data["message"],
            icon: "check",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success",
          });
        })
        .catch((error) => {
          this.$notify({
            message: error,
            icon: "error",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
    /**
     * Function to update peak detect window for fw
     */
    update_fw_window() {
      this.bscanCorrelationPlotData[1].y = [
        this.frontWall[0],
        this.frontWall[0],
      ];
      this.bscanCorrelationPlotData[2].y = [
        this.frontWall[1],
        this.frontWall[1],
      ];
    },
    /**
     * Function to update peak detect window for bw
     */
    update_bw_window() {
      this.bscanCorrelationPlotData[3].y = [this.backWall[0], this.backWall[0]];
      this.bscanCorrelationPlotData[4].y = [this.backWall[1], this.backWall[1]];
    },
    /**
     * Function to fetch correlated bscan data
     * @param {string} uuid - uuid of inspection
     */
    async get_bscans_correlation(uuid) {
      const token = await this.$auth.getTokenSilently();
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      this.bscanCorrelationLoading = true;
      const files_endpoint =
        this.analyserApi.server +
        this.analyserApi.bscansCorrelation +
        uuid +
        "/" +
        this.groupSelected;
      axios
        .get(files_endpoint, config)
        .then((response) => {
          //console.log(response.data);
          this.bscansCorrelation = response.data;
          console.log(this.bscansCorrelation[this.selectedFileCorrelation]);

          this.bscanCorrelationLoading = false;
          console.log(this.bscanCorrelationLoading);
          const xMax = this.bscansCorrelation[this.selectedFileCorrelation][0]
            .length;
          this.wtPlotData = [
            {
              y: this.currentPeaks[this.selectedFileCorrelation].WT,
              mode: "markers",
              type: "scatter",
              name: "WT [mm]",
              marker: {
                color: "rgb(255, 0, 0)",
              },
            },
          ];
          this.bscanCorrelationPlotData = [
            {
              z: this.bscansCorrelation[this.selectedFileCorrelation],
              type: "heatmap",
              colorscale: "Jet",
              name: "B-SCAN",
            },
            {
              x: [0, xMax],
              y: [this.frontWall[0], this.frontWall[0]],
              mode: "lines",
              line_color: "indigo",
              type: "scatter",
              name: "FW-window-min",
            },
            {
              x: [0, xMax],
              y: [this.frontWall[1], this.frontWall[1]],
              mode: "lines",
              types: "scatter",
              line_color: "indigo",
              name: "FW-window-max",
            },
            {
              x: [0, xMax],
              y: [this.backWall[0], this.backWall[0]],
              mode: "lines",
              type: "scatter",
              line_color: "green",
              name: "BW-window-min",
            },
            {
              x: [0, xMax],
              y: [this.backWall[1], this.backWall[1]],
              mode: "lines",
              type: "scatter",
              line_color: "green",
              name: "BW-window-max",
            },
            {
              y: this.currentPeaks[this.selectedFileCorrelation].FW,
              mode: "markers",
              type: "scatter",
              name: "Front-wall",
              marker: {
                color: "rgb(255, 0, 0)",
              },
            },
            {
              y: this.currentPeaks[this.selectedFileCorrelation].BW,
              mode: "markers",
              type: "scatter",
              name: "Back-wall",
              marker: {
                color: "rgb(0, 255, 0)",
              },
            },
          ];
        })
        .catch((error) => {
          this.$notify({
            message: error,
            icon: "error",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
    /**
     * Function to set page
     * @param {string} pageStr - string indicating page name
     */
    set_page(pageStr) {
      this.page = pageStr;
    },
    /**
     * Function to save selected measurements
     */
    async save_selected() {
      const token = await this.$auth.getTokenSilently();
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const endpoint =
        this.analyserApi.server +
        this.analyserApi.save_files +
        this.selectedInspection.uuid +
        "/" +
        this.groupSelected;

      axios
        .post(endpoint, this.inspectionFiles, config)
        .then((response) => {
          this.$notify({
            message: response.data["message"],
            icon: "check",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success",
          });
        })
        .catch((error) => {
          this.$notify({
            message: error,
            icon: "error",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
    /**
     * Function to set plot data
     */
    set_plot_data() {
      this.bscanPlotData = [
        {
          z: this.bscans[this.selectedFile],
          type: "heatmap",
          colorscale: "Jet",
          name: "B-SCAN",
        },
      ];
    },
    /**
     * Function to set plot data for correlation bscans
     */
    set_plot_data_correlation() {
      const xMax = this.bscansCorrelation[this.selectedFileCorrelation][0]
        .length;
      this.wtPlotData = [
        {
          y: this.currentPeaks[this.selectedFileCorrelation].WT,
          mode: "markers",
          type: "scatter",
          name: "WT [mm]",
          marker: {
            color: "rgb(255, 0, 0)",
          },
        },
      ];
      this.bscanCorrelationPlotData = [
        {
          z: this.bscansCorrelation[this.selectedFileCorrelation],
          type: "heatmap",
          colorscale: "Jet",
          name: "B-SCAN",
        },
        {
          x: [0, xMax],
          y: [this.frontWall[0], this.frontWall[0]],
          mode: "lines",
          line_color: "indigo",
          type: "scatter",
          name: "FW-window-min",
        },
        {
          x: [0, xMax],
          y: [this.frontWall[1], this.frontWall[1]],
          mode: "lines",
          types: "scatter",
          line_color: "indigo",
          name: "FW-window-max",
        },
        {
          x: [0, xMax],
          y: [this.backWall[0], this.backWall[0]],
          mode: "lines",
          type: "scatter",
          line_color: "green",
          name: "BW-window-min",
        },
        {
          x: [0, xMax],
          y: [this.backWall[1], this.backWall[1]],
          mode: "lines",
          type: "scatter",
          line_color: "green",
          name: "BW-window-max",
        },
        {
          y: this.currentPeaks[this.selectedFileCorrelation].FW,
          mode: "markers",
          type: "scatter",
          name: "Front-wall",
          marker: {
            color: "rgb(255, 0, 0)",
          },
        },
        {
          y: this.currentPeaks[this.selectedFileCorrelation].BW,
          mode: "markers",
          type: "scatter",
          name: "Back-wall",
          marker: {
            color: "rgb(0, 255, 0)",
          },
        },
      ];
    },
    /**
     * debug function logging smth
     */
    logFiles() {
      console.log(this.inspectionFiles);
    },
    /**
     * Function to populate menu
     */
    async populate_menu() {
      //define the query
      var query = {
        query:
          "SELECT c.id, c.tag, c.user, c.material, c.coating, c.coating_inner, c.wallthickness_expected, c.wallthickness_expected_validation FROM c",
      };
      //get token
      var token = await this.$auth.getTokenSilently();
      var header = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };

      //construct endpoint
      var endpoint =
        this.apiEndpoints.base + this.apiEndpoints.pipescanner.custom;

      //request
      axios
        .post(endpoint, query, header)
        .then((response) => {
          this.inspections = response.data[
            this.groupSelected + "-pipescanner-inspections"
          ].map((x) => {
            x["uuid"] = x.id;
            return x;
          });
        })
        .catch((error) => {
          this.$notify({
            message: error,
            icon: "check",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
    /**
     * Function to set inspection to analyse
     * @param {string} item - inspection item to set
     */
    async set_inspection(item) {
      const token = await this.$auth.getTokenSilently();
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      this.selectedInspection = item;
      this.initialising = true;
      const init_endpoint =
        this.analyserApi.server +
        this.analyserApi.init +
        item.uuid +
        "/" +
        this.groupSelected;
      axios
        .get(init_endpoint, config)
        .then((response) => {
          this.initialising = false;
          this.$notify({
            message: response.data["message"],
            icon: "check",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success",
          });
          this.get_files(item.uuid);
          this.get_bscans(item.uuid);
        })
        .catch((error) => {
          this.$notify({
            message: error,
            icon: "error",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
    /**
     * Function to fetch inspection file data
     * @param {string} uuid - uuid of inspection
     */
    async get_files(uuid) {
      const token = await this.$auth.getTokenSilently();
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const files_endpoint =
        this.analyserApi.server +
        this.analyserApi.files +
        uuid +
        "/" +
        this.groupSelected;

      axios
        .get(files_endpoint, config)
        .then((response) => {
          //console.log(response.data);
          this.inspectionFiles = response.data;
          this.fileNames = response.data.map((x) => x.name);
          //this.fileFilterSelected = this.fileNames[0];
          //response.data
          //  .map((x) => x.name)
          //  .forEach((item) => {
          //    console.log(item);
          //    this.currentPeaks[item] = { FW: [0, 0], BW: [0, 0], WT: [0, 0] };
          //  });
          const peaks_endpoint =
            this.analyserApi.server +
            this.analyserApi.get_saved_peaks +
            uuid +
            "/" +
            this.groupSelected;
          axios
            .get(peaks_endpoint, config)
            .then((response) => {
              this.currentPeaks = response.data;
            })
            .catch((error) => {
              this.$notify({
                message: error,
                icon: "error",
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "danger",
              });
            });

          const comments_endpoint =
            this.analyserApi.server +
            this.analyserApi.get_comments +
            uuid +
            "/" +
            this.groupSelected;
          axios
            .get(comments_endpoint, config)
            .then((response) => {
              this.comments_analyst = response.data;
              console.log(response.data);
            })
            .catch((error) => {
              this.$notify({
                message: error,
                icon: "error",
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "danger",
              });
            });

          //console.log(this.fileNames);
          this.selectedFile = this.fileNames[0];
        })
        .catch((error) => {
          this.$notify({
            message: error,
            icon: "error",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
    /**
     * Function to handle peak detect calls
     */
    async detect_peaks() {
      this.waitingForPeaks = true;
      const token = await this.$auth.getTokenSilently();
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const endpoint =
        this.analyserApi.server +
        this.analyserApi.peak_detect +
        this.selectedInspection.uuid +
        "/" +
        this.groupSelected;

      const minDistFW2L = 0;
      const minDistL2BW = 0;

      if (this.orgWTUse == "validation") {
        var wtorg = this.selectedInspection.wallthickness_expected_validation;
      } else {
        var wtorg = this.selectedInspection.wallthickness_expected;
      }

      var settings = {
        algorithm: this.selectedAlgorithm,
        inspection_file: this.selectedFileCorrelation,
        material: this.selectedInspection.material,
        wall_thickness_original: wtorg,

        //Now the variables,
        search_start: this.searchStart,
        search_stop: this.searchStop,
        min_distance_bw: this.minDistance,
        max_distance_bw: this.maxDistance,
        noise_lvl_fw: this.noiseFW,
        noise_lvl_bw: this.noiseBW,
        last_peak_preferred: this.preferLastPeak

      };
      console.log(JSON.stringify(settings));
      axios
        .post(endpoint, settings, config)
        .then((response) => {
          this.currentPeaks[this.selectedFileCorrelation].FW =
            response.data.front_wall;
          this.currentPeaks[this.selectedFileCorrelation].BW =
            response.data.back_wall;
          this.currentPeaks[this.selectedFileCorrelation].WT = response.data.wt;
          this.bscanCorrelationPlotData[5].y = response.data.front_wall;
          this.bscanCorrelationPlotData[6].y = response.data.back_wall;
          this.wtPlotData[0].y = response.data.wt;
          this.waitingForPeaks = false;
        })
        .catch((error) => {
          console.log(error);
          this.waitingForPeaks = false;
          this.$notify({
            message: error,
            icon: "error",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
    /**
     * Function to fetch bscan data
     * @param {string} uuid - uuid of inspection
     */
    async get_bscans(uuid) {
      const token = await this.$auth.getTokenSilently();
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      this.bscanLoading = true;
      const files_endpoint =
        this.analyserApi.server +
        this.analyserApi.bscans +
        uuid +
        "/" +
        this.groupSelected;
      axios
        .get(files_endpoint, config)
        .then((response) => {
          //console.log(response.data);
          this.bscans = response.data;
          this.bscanLoading = false;
          console.log(this.bscans[this.selectedFile]);
          this.bscanPlotData = [
            {
              z: this.bscans[this.selectedFile],
              type: "heatmap",
              colorscale: "Jet",
              name: "B-SCAN",
            },
          ];
        })
        .catch((error) => {
          this.$notify({
            message: error,
            icon: "error",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
  },
};
</script>
